import { useEffect, useState } from 'react';
import { useAsyncOperationState } from '../../../../dorian-shared/hooks/useAsyncOperationState';
import { api } from '../../../api';
import { StoredOffer } from '../components/OfferForm/offerFormLogic';

export function useOffer(id: number) {
  const [requestState, { setToLoading, setToError, setToSuccess }] = useAsyncOperationState();
  const [offer, setOffer] = useState<StoredOffer>();
  // Genuinely not found and the upstream being unreachable read different words to the operator —
  // the HTTP status editor-api returns is what tells them apart.
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setToLoading();
    api.get(`/v1/offers/${id}`)
      .then((response) => setOffer(response.data.offer))
      .then(() => setToSuccess())
      .catch((error) => {
        setNotFound(error.response?.status === 404);
        setToError();
      });
  }, [id, setToError, setToLoading, setToSuccess]);
  return {
    requestState, offer, setOffer, notFound,
  };
}
